import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import { ListTenant } from "../data/data";

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface PaymentTenantProps {
  tenants: ListTenant[];
}

const StatusPayment: React.FC<PaymentTenantProps> = ({ tenants }) => {
  // Calculate active and inactive counts
  const data: DataItem[] = React.useMemo(() => {
    const paymentCount: { [key: string]: number } = {
      Paid: 0,
      Unpaid: 0,
    };

    tenants.forEach(tenant => {
      if (tenant.StatusPayment) {
        paymentCount["Paid"] += 1;
      } else {
        paymentCount["Unpaid"] += 1;
      }
    });

    const dataArray: DataItem[] = Object.keys(paymentCount).map(title => ({
      title,
      value: paymentCount[title],
      percentage: 0,
    }));

    const total = dataArray.reduce((acc, item) => acc + item.value, 0);

    dataArray.forEach(item => {
      item.percentage = Math.round((item.value / total) * 100);
    });

    return dataArray;
  }, [tenants]);

  const total = data.reduce((acc, item) => acc + item.value, 0);

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Payment Status</h3>
      <PieChart
        data={data}
        visibleSegments={data}
        ariaDescription="Donut chart showing vehicle statuses."
        ariaLabel="Donut chart"
        hideFilter
        hideTitles
        hideLegend
        innerMetricDescription="total units"
        innerMetricValue={total.toString()}
        size="small"
        variant="donut"
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
            <Button>Clear filter</Button>
          </Box>
        }
      />
    </div>
  );
};

export default StatusPayment;
